import { InspirationalCopyExperimentVariant } from '@core/models/user/flags';

export type HomeSectionLabels = {
  topTen: string;
  hotTournaments: string;
  liveEvents: string;
  news: string;
  superLive: string;
  popularSuperbets: string;
};

export const variantTranslationKeyHomeSectionSubtitle: Record<InspirationalCopyExperimentVariant, HomeSectionLabels> = {
    [InspirationalCopyExperimentVariant.None]: {
        superLive: '',
        popularSuperbets: '',
        hotTournaments: '',
        topTen: '',
        liveEvents: '',
        news: '',
    },
    [InspirationalCopyExperimentVariant.A]: {
        superLive: '',
        popularSuperbets: '',
        hotTournaments: '',
        topTen: '',
        liveEvents: '',
        news: '',
    },
    [InspirationalCopyExperimentVariant.B]: {
        superLive: 'grtw.pe160.variantB.super live',
        popularSuperbets: 'grtw.pe160.variantB.superOffer.popularSuperbets',
        hotTournaments: 'grtw.pe160.variantB.hot tournaments',
        topTen: 'grtw.pe160.variantB.home.topTen.title',
        liveEvents: 'grtw.pe160.variantB.live events',
        news: 'grtw.pe160.variantB.news',
    },
    [InspirationalCopyExperimentVariant.C]: {
        superLive: 'grtw.pe160.variantC.super live',
        popularSuperbets: 'grtw.pe160.variantC.superOffer.popularSuperbets',
        hotTournaments: 'grtw.pe160.variantC.hot tournaments',
        topTen: 'grtw.pe160.variantC.home.topTen.title',
        liveEvents: 'grtw.pe160.variantC.live events',
        news: 'grtw.pe160.variantC.news',
    },
};
